import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    articles: {}, // Store articles by unique key
    currentArticle: null,
    isSubscriber: false,
    newVisitor: false, 
    newGuest: false, 
    thumbnail: null, 
    loading: false,
    error: null,
};

const articleSlice = createSlice({
    name: "article",
    initialState,
    reducers: {
        setArticle: (state, action) => {
            const article = action.payload;
            const articleKey = `${article.year}-${article.month}-${article.day}-${article.title}`;

            state.articles[articleKey] = article; //Store article by unique key
            state.currentArticle = articleKey;
            state.isSubscriber = action.payload.isSubscriber;
            state.newVisitor = action.payload.newVisitor; 
            state.newGuest = action.payload.newGuest; 
            state.thumbnail = action.payload.thumbnail; 
            state.error = null;
            state.loading = false;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        }
    },
});

export const { setArticle, setLoading, setError } = articleSlice.actions;
export default articleSlice.reducer;
